import { render, staticRenderFns } from "./addcompany.vue?vue&type=template&id=088e1eb0&scoped=true&"
import script from "./addcompany.vue?vue&type=script&lang=js&"
export * from "./addcompany.vue?vue&type=script&lang=js&"
import style0 from "./addcompany.vue?vue&type=style&index=0&id=088e1eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e1eb0",
  null
  
)

export default component.exports